import { z } from 'zod';

export const featureFlagsFormSchema = z.object({
  flags: z.array(
    z.object({
      featureName: z.string(),
      description: z.string(),
      isEnabled: z.boolean(),
    }),
  ),
});
